export default __webpack_public_path__ + "static/media/cp_geo_ai.fd3ffd23.svg";